module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.7799/images/blue-grey-beard-glasses/blue-grey-beard-glasses@2x.png"